import { createContext, useContext, useEffect, useState } from "react";
import { productOperationsList } from "./constants/product.constants";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { message } from "constants/responses/message";
import { getProjectByIdApi } from "API/apis/project/getProjectById";

const ProductContext = createContext({
  currentOperationPage: "",
  setCurrentOperationPage: () => {},
  list: [],
  setList: () => {},
  previewProduct: {},
  setPreviewProduct: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
  currentProject: 0,
  setCurrentProject: () => {},
  productsSelectedForTask: [],
  setProductsSelectedForTask: () => {},
  bdc: "",
  setBdc: () => {},
  currentProjectDetail: {},
  setCurrentProjectDetail: () => {},
  selectedRowId: [],
  setSelectedRowId: () => {},
});

export const ProductProvider = ({ children }) => {
  const { setIsInitializing, setError } = useGlobalContext();
  const [list, setList] = useState([]);
  const [previewProduct, setPreviewProduct] = useState({});
  const { projectId } = useParams();
  const [currentProject, setCurrentProject] = useState(projectId);
  const [reloadRequired, setReloadRequired] = useState(false);
  const [currentProjectDetail, setCurrentProjectDetail] = useState();
  const [bdc, setBdc] = useState("");
  const [currentOperationPage, setCurrentOperationPage] = useState(
    productOperationsList.listProduct
  );
  const [productsSelectedForTask, setProductsSelectedForTask] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState([]);

  useEffect(() => {
    const fetchData = async (projectId) => {
      try {
        setIsInitializing(true);
        const { data, status } = await getProjectByIdApi(projectId);
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setCurrentProjectDetail(data);
        setBdc(data.createdBy);
        setIsInitializing(false);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
      }
    };
    fetchData(projectId);
  }, []);
  return (
    <ProductContext.Provider
      value={{
        currentOperationPage,
        setCurrentOperationPage,
        list,
        setList,
        previewProduct,
        setPreviewProduct,
        reloadRequired,
        setReloadRequired,
        currentProject,
        setCurrentProject,
        productsSelectedForTask,
        setProductsSelectedForTask,
        bdc,
        setBdc,
        currentProjectDetail,
        setCurrentProjectDetail,
        selectedRowId,
        setSelectedRowId,
      }}
    >
      <>{children}</>
    </ProductContext.Provider>
  );
};

export const useProductContext = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error("useProductContext must be used within a ProductProvider");
  }
  return context;
};
